import { FunctionComponent, PropsWithChildren } from 'react';

import { ReactComponent as UncheckedIcon } from '../../../../../assets/icons/checkbox-icons/unchecked.svg';
import Checkbox from '../../../Checkbox';
import TableCell from '../../../TableCell';
import { Alignments } from '../../enums/alignments.enum';
import { getRowValue } from '../../utils/get-row-value.util';
import { TableCellsPropsModel } from './models/table-cells-props.model';

const TableCells: FunctionComponent<TableCellsPropsModel> = ({
  columns,
  checked,
  index,
  onRowCheck,
  row,
  selectionCheckbox,
}: PropsWithChildren<TableCellsPropsModel>): JSX.Element => {
  return (
    <>
      {selectionCheckbox && (
        <TableCell
          align={Alignments.CENTER}
          key={`table-cell-selection-${index}`}
        >
          <Checkbox
            icon={<UncheckedIcon />}
            className="table-multiselect-checkbox"
            key={`checkbox-selection-col-${index}`}
            onClick={() => onRowCheck(row.id as number)}
            checked={checked}
            sx={{
              width: 'auto',
            }}
          />
        </TableCell>
      )}
      {columns.map((column, colIndex) => (
        <TableCell
          align={column.alignment}
          colSpan={column.colSpan}
          key={`col-${column.field}${colIndex}`}
          sx={{
            ...(column.width && {
              width: column.width,
            }),
          }}
        >
          {getRowValue(row, column)}
        </TableCell>
      ))}
    </>
  );
};

export default TableCells;
